import { render, staticRenderFns } from "./EventReminder2.vue?vue&type=template&id=b6081cb4&"
import script from "./EventReminder2.vue?vue&type=script&lang=js&"
export * from "./EventReminder2.vue?vue&type=script&lang=js&"
import style0 from "./EventReminder2.vue?vue&type=style&index=0&id=b6081cb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports